import React, { memo, useEffect } from 'react';
import { createBrowserHistory as createHistory } from 'history';
import { Router as ReactRouter, Route, Switch, Redirect } from 'react-router';
import { useDispatch } from 'react-redux';

import { changeLocation } from 'store/location';
import useAnalytics from 'helpers/useAnalytics';
import CoreLayout from 'components/Layouts/CoreLayout';
import Bubble from 'components/onboarding/Bubble';

import routes from './routes';

const history = createHistory();

export const HelpArticleLinkContext = React.createContext();
export const HelpArticleLinkTextContext = React.createContext();

const routeElems =
  routes &&
  routes.map((route, index) => (
    <Route
      path={route.path}
      exact={route.exact}
      key={`route-${index}`}
      render={props => {
        return (
          <HelpArticleLinkContext.Provider value={route.helpArticleLink}>
            <HelpArticleLinkTextContext.Provider value={route.helpArticleLinkText}>
              <route.component {...props} />
            </HelpArticleLinkTextContext.Provider>
          </HelpArticleLinkContext.Provider>
        );
      }}
    />
  ));

function Router() {
  const dispatch = useDispatch();
  const analytics = useAnalytics();

  useEffect(() => {
    history.listen(({ pathname }) => {
      analytics.page(pathname);
    });

    const unlisten = history.listen(location => {
      dispatch(changeLocation(location));
    });

    return unlisten;
  }, [dispatch]);

  return (
    <ReactRouter history={history}>
      <CoreLayout>
        <Bubble />
        <Switch>
          {routeElems}
          <Redirect to="/404" />
        </Switch>
      </CoreLayout>
    </ReactRouter>
  );
}

export default memo(Router);
